import React, { Component } from "react";
import classNames from "classnames";
import Icon from "../Icon";

import styles from "./Quote.css";

class Quote extends Component {
  render() {
    return (
      <div className={classNames(styles.root, this.props.styled ? styles.styled : styles.plain)}>
        {this.props.styled && <Icon name="quote" description="Quote" path="img" className={styles.icon}/>}
        {this.props.children}
      </div>
    );
  }
}

export default Quote;



// WEBPACK FOOTER //
// ./src/components/Library/Quote/Quote.js